<template>
  <BlockUI :blocked="loading">
    <Toast />
    <div class="grid grid-cols-6 gap-2">

      <div class="col-span-6 mb-4">
        <label for="cuit">CUIT</label>
        <InputMask id="cuit" mask="99-99999999-9" v-model="data.save.cuit" placeholder="99-99999999-9" class="ml-2 w-full" autofocus unmask="true" />
        <InlineMessage v-if="!!errores.cuit">{{ errores.cuit }}</InlineMessage>
      </div>

      <div class="col-span-6 mb-4">
        <label for="name">Nombre</label>
        <InputText id="name" v-model.trim="data.save.nombre" required="true" :class="{'p-invalid': !!errores.nombre}" class="ml-2 w-full" />
        <InlineMessage v-if="!!errores.nombre">{{ errores.nombre }}</InlineMessage>
      </div>

      <div class="col-span-6 mb-4">
        <label for="address">Domicilio</label>
        <Textarea id="address" v-model="data.save.domicilio" rows="3" cols="20" class="ml-2 w-full" />
      </div>

      <div class="col-span-6 mb-4">
        <label for="country" class="mb-3">Provincia</label>
        <Dropdown id="country" v-model="country" :options="countries" optionValue="idProvincia" optionLabel="nombre" :filter="true" :showClear="true"
                  placeholder="Seleccione Provincia" class="ml-2 w-full" optionGroupLabel="nombre" optionGroupChildren="provincias"
                  @change="getLocalidades">
          <template #optiongroup="slotProps">
            <div class="flex items-center">
              <img v-if="slotProps.option.code" :src="getImage(slotProps.option.code)" width="18" />
              <div>{{slotProps.option.nombre}}</div>
            </div>
          </template>
        </Dropdown>
      </div>

      <div v-if="country" class="col-span-6 mb-4">
        <label for="city" class="mb-3">Localidad</label>
        <Dropdown id="city" v-model="data.save.idLocalidad" :options="cities" optionValue="idLocalidad" optionLabel="nombre" :filter="true" placeholder="Seleccione Localidad" class="ml-2 w-full">
        </Dropdown>
      </div>

      <div class="col-span-6 sm:col-span-3 mb-4">
        <label for="contact">Contacto</label>
        <InputText id="contact" v-model.trim="data.save.contacto" maxlength="50" class="ml-2 w-full" />
      </div>

      <div class="col-span-6 sm:col-span-3 mb-4">
        <label for="phone">Tel&eacute;fono</label>
        <InputMask id="phone" mask="(999) 999-9999" v-model="data.save.telefono" placeholder="(999) 999-9999" class="ml-2 w-full" />
      </div>

      <div class="col-span-6 sm:col-span-3 mb-4">
        <label for="resolution">Resoluci&oacute;n</label>
        <InputText id="resolution" v-model.trim="data.save.contacto" maxlength="50" class="ml-2 w-full" />
      </div>

      <div class="col-span-6 sm:col-span-3 mb-4">
        <label for="quota-value">Valor Cuota</label>
        <InputNumber inputId="quota-value" v-model="data.save.cuotaFija" mode="currency" currency="USD" locale="en-US" class="ml-2 w-full" />
      </div>

      <div class="col-span-6 sm:col-span-2 mb-4">
        <label for="start-date">Comienza</label>
        <Calendar inputId="start-date" v-model="data.save.inicio" :showIcon="true" class="ml-2 w-full" />
      </div>

      <div class="col-span-6 sm:col-span-2 mb-4">
        <label for="end-date">Vence</label>
        <Calendar inputId="end-date" v-model="data.save.fin" :showIcon="true" class="ml-2 w-full" />
      </div>

      <div class="col-span-6 sm:col-span-2 mb-4">
        <label for="renew-date">Renovar</label>
        <Calendar inputId="renew-date" v-model="data.save.renovar" :showIcon="true" class="ml-2 w-full" />
      </div>



      <div class="col-span-6 mb-4">
        <h4 class="mb-4">Opciones</h4>
        <div class="grid grid-cols-6 gap-4">
          <div class="col-span-6 sm:col-span-2">
            <Checkbox inputId="engage" name="engage" value="checked" v-model="data.save.contratados" class="mr-2 w-full" />
            <label for="engage">Contratados</label>
          </div>
          <div class="col-span-6 sm:col-span-2">
            <Checkbox inputId="fixed-value" name="fixed-value" value="checked" v-model="data.save.valorFijo" class="mr-2 w-full" />
            <label for="fixed-value">Valor Fijo</label>
          </div>
          <div class="col-span-6 sm:col-span-2">
            <Checkbox inputId="individual" name="individual" value="checked" v-model="data.save.contratoIndividual" class="mr-2 w-full" />
            <label for="individual">Contrato Individual</label>
          </div>
          <div class="col-span-6">
            <label for="type" class="mb-3">Tipo</label>
            <Dropdown id="type" v-model="data.save.tipo" :options="data.types" optionValue="value" optionLabel="label" placeholder="Seleccione Tipo" class="ml-2 w-full">
            </Dropdown>
          </div>
        </div>
      </div>


      <div class="col-span-6 sm:col-span-3 mb-4">
        <label for="discount">Pronto Pago Descuento</label>
        <InputNumber id="discount" v-model="data.save.prontoPagoDescuento" mode="currency" currency="USD" locale="en-US" class="ml-2 w-full" />
      </div>
      <div class="col-span-6 sm:col-span-3 mb-4">
        <label for="amount">Pronto Pago Importe</label>
        <InputNumber id="amount" v-model="data.save.prontoPagoImporte" mode="currency" currency="USD" locale="en-US" class="ml-2 w-full" />
      </div>

      <div class="col-span-6 sm:col-span-3 justify-self-center">
        <Button label="Cancelar" icon="pi pi-times" class="p-button-text" />
      </div>
      <div class="col-span-6 sm:col-span-3 justify-self-center">
        <Button label="Grabar" icon="pi pi-check" @click="Save" :disabled="loading" />
      </div>
    </div>
  </BlockUI>
</template>

<script>
  import { reactive, ref, onMounted } from 'vue';
  import { object, string } from "yup";
  import WService from '@/plugins/ws';
  import Toast from 'primevue/toast';
  import { useToast } from "primevue/usetoast";
  import InputNumber from 'primevue/inputnumber';
  import InputText from 'primevue/inputtext';
  import InputMask from 'primevue/inputmask';
  import Textarea from 'primevue/textarea';
  import Dropdown from 'primevue/dropdown';
  import Checkbox from 'primevue/checkbox';
  import Calendar from 'primevue/calendar';
  import Button from 'primevue/button';
  import InlineMessage from 'primevue/inlinemessage';
  import BlockUI from 'primevue/blockui';

  export default {
    props: {
      info: Object,
    },
    emits: ['closeModal'],
    components: {
      InputNumber, InputText, InputMask, Textarea, Dropdown,
      Checkbox, Calendar, Button, Toast, InlineMessage, BlockUI
    },
    setup(props, { emit }) {
      onMounted(() => {
        loading.value = true;
        wService.value.getMethod('Paises/Provincias/').then(info => {
          let cargar = true;
          countries.value = info;
          if (props.info) {
            data.save = props.info;
            let idLocal = data.save.idLocalidad;
            if (idLocal !== 0) {
              cargar = false;
              wService.value.getMethod('LocalidadDBs/Provincia/' + idLocal).then(res => {
                cities.value = res;
                if (res.length > 0)
                  country.value = res[0].idProvincia;
                loading.value = false;
              }).catch(e => {
                console.log("Prov:", e);
                loading.value = false;
              });
            }
          }
          if (cargar)
            loading.value = false;
        }).catch(err => {
          loading.value = false;
          console.log(err.message);
        });
      })

      const data = reactive({
        save: {
          idEmpresa: 0,
          cuit: '',
          nombre: '',
          domicilio: null,
          contacto: null,
          telefono: null,
          resolucion: null,
          cuotaFija: null,
          inicio: null,
          fin: null,
          renovar: null,
          idLocalidad: null,
          contratados: false,
          prontoPagoDescuento: null,
          prontoPagoImporte: null,
          valorFijo: false,
          contratoIndividual: false,
          tipo: 'Normal',
          periodoFacturado: '',
          anulado: false
        },
        types: [
          { value: 'Normal', label: 'Normal' },
          { value: 'Extra', label: 'Extra' },
          { value: 'ValorFijo', label: 'Valor Fijo' },
          { value: 'Individual', label: 'Individual' },
          { value: 'Joven', label: 'Plan Joven' },
        ]
      });
      const wService = ref(new WService());
      const toast = useToast();
      const loading = ref(false);
      const countries = ref([]);
      const country = ref();
      const cities = ref([]);
      const errores = ref({});
      const schemaSave = object().shape({
        cuit: string().required("El campo CUIT debe completarse"),
        nombre: string().required("El campo nombre debe completarse"),
      });

      const getImage = (code) => {
        code = code.toLowerCase();
        return require(`@/assets/flags/${code}.png`);
      };

      const getLocalidades = (ev) => {
        if (ev.value) {
          loading.value = true;
          data.idLocalidad = null;
          wService.value.getMethod('LocalidadDBs/' + ev.value).then(info => {
            cities.value = info;
            loading.value = false;
          }).catch(err => {
            loading.value = false;
            console.log(err.message);
          });
        }
      };

      const Save = () => {
        loading.value = true;
        schemaSave.validate(data.save, { abortEarly: false }).then(() => {
          const toSave = JSON.stringify(data.save);
          let id = data.save.idEmpresa === 0 ? '' : data.save.idEmpresa;
          wService.value.postMethod('Empresas/' + id, toSave).then(res => {
            loading.value = false;
            console.log("res: ", res);
            emit("closeModal", res);
          }).catch(error => {
            loading.value = false;
            if (error.response) {
              toast.add({ severity: 'warn', summary: 'Error!', detail: error.response.data, life: 3000 });
              if (error.response.data.errors) {
                for (const [value] of Object.entries(error.response.data.errors)) {
                  console.log(error.response.data.errors[value][0]);
                }
              }
            } else if (error.request) {
              console.log("Error Request", error.request);
              console.log("Error Message", error.request.message);
            } else {
              console.log(error.toJSON());
            }
          });
        }).catch(err => {
          toast.add({ severity: 'warn', summary: 'Atencion!', detail: 'Verifique los campos para poder grabar', life: 3000 });
          loading.value = false;
          err.inner.forEach(error => {
            errores.value[error.path] = error.message;
          });
        });
      };

      return {
        data, loading, countries, country, cities, errores, 

        getImage, getLocalidades, Save,
      };
    }
  }
</script>